import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveDepartmentMutation = gql`
   mutation SaveDepartment($department: DepartmentInput!) {
      department: saveDepartment(department: $department) {
         departmentId
         name
      }
   }
`;
